<template>
  <footer>
    <slot />
  </footer>
</template>
